import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function getDetailsFailure(draft: Draft<IInterventionData>) {
  draft.getDetails.config.isLoading = false;
}

export default getDetailsFailure;
